var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 29C23.9404 29 24.5 28.4404 24.5 27.75C24.5 27.0596 23.9404 26.5 23.25 26.5C22.5596 26.5 22 27.0596 22 27.75C22 28.4404 22.5596 29 23.25 29Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 29C15.9404 29 16.5 28.4404 16.5 27.75C16.5 27.0596 15.9404 26.5 15.25 26.5C14.5596 26.5 14 27.0596 14 27.75C14 28.4404 14.5596 29 15.25 29Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7402 8.25C11.9294 8.2501 12.9158 9.0507 13.2295 10.1201H25.7305C27.8331 10.1204 29.4394 11.8371 29.2881 13.9336L28.748 21.4336V21.4375C28.6083 23.2543 27.0259 24.74 25.1904 24.7402H14.54C12.4631 24.7402 10.8251 22.966 11.0029 20.8955L11.833 10.9375L11.8359 10.8193C11.8219 10.2366 11.34 9.75012 10.7402 9.75H9C8.58579 9.75 8.25 9.41421 8.25 9C8.25 8.58579 8.58579 8.25 9 8.25H10.7402ZM16 14.25C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H28C28.4142 15.75 28.75 15.4142 28.75 15C28.75 14.5858 28.4142 14.25 28 14.25H16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionactive);
export default __webpack_public_path__ + "static/media/subscriptionactive.4b7c08703b040ee4f595edb4841b2cfd.svg";
export { ForwardRef as ReactComponent };